
function UnitStatus() {
    /// <summary>
    /// This object provides js functions for the Widget.Status.UnitStatus <br/>
    /// The code would be easier of we wouldn't have to handle old CX and new units separately.
    /// <br/>
    /// Author: ARF<br />
    /// Date: 10.7.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
 	/// **********************************************************************<br />
    /// *** v1.0.1 (MWI) - 12.12.2018                                        *<br />
    /// **********************************************************************<br />
    /// * - added filter for alarms                                          *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 18.7.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.listHeight = 0;
    this.currentDetailObj = null;
    this.openTickets = null;
}

UnitStatus.prototype = new vcTemplate();

UnitStatus.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);

        //init the full-ext search
        me.listHeight = parseInt(me.height - me.visual.find("#div-menu").height() - 20, 10);
        me.visual.find(".vc-list").height(me.listHeight);

        me.fetchOpenTickets();

        me.fetchEntries();

        me.visual.find("#div-filter").vcFilter({ callback: function () { me.hideDetails(); me.filter(); } });
        //selections
        me.visual.find("#chb-selection").off("click").on("click", function () { me.selectAll($(this)); });
		me.visual.find("#chb-alarm-selection").off("click").on("click", function () { me.selectAllAlarms($(this)); });

        me.visual.find(".device-list .vc-list-selection").off("click", ".chb").on("click", ".chb", function (e) { me.activateBtnCmd(true); e.stopPropagation() });
        //tasks (cmds)
        me.visual.find("#ddl-cmd").off("change").on("change", function () { me.setCmd($(this)); });
        me.visual.find("#txt-cmd").off("keyup").on("keyup", function () { me.activateBtnCmd(true); });
        me.visual.find("#div-btn-send").off("click").on("click", function () { me.sendCmd(); });

        me.visual.find(".device-list .vc-list-selection").off("click", ".icon-del").on("click", ".icon-del", function (e) { me.delete($(this)); e.stopPropagation() });
       
        me.visual.find(".device-list .vc-list-selection").off("click", ".vc-list-item").on("click", ".vc-list-item", function (e) { me.showDetails($(this)); e.stopPropagation() });


        me.visual.find("#div-btn-reload").off("click").on("click", function () { me.hideDetails(); me.fetchEntries(); });


        me.visual.find(".div-details .button-toggle").off("click").on("click", function () {
            me.visual.find(".div-details-menu .button-toggle").removeClass("button-toggle-active");
            $(this).addClass("button-toggle-active");
            me.showDetailContent();
        }).button();

    return true;
    } catch (ex) { me.writeError('init', ex); return false }

}



UnitStatus.prototype.fetchEntries = function () {
    /// <summary>
    ///  This function generates a vc-list with all given entries. 
    /// </summary>
    var me = this;
    var sTmp = "";
    var isBluid;
    var list;
    var sError;
    var sumTasks = 0;
    var sumAlarms = 0;
    var sumBroken = 0;
   
    try {
        if (me.error) {
            return false;
        }
        me.visual.find(".device-list .vc-list-selection").html(me.vcC.getLoadingIcon());

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({"type":1,"activeOnly":me.visual.find("#chb-active").prop("checked")}),
       function (result) {

           if (result === null) { me.showMessage(me.resources.err_loadData, true);return false;}

           if (result.rows === null) {me.visual.find(".device-list .vc-list-selection").html("<div class='note'>" + me.resources.noEntriesExist + "</div>");return false;}


           for (var i = 0; i < result.rows.length; i++) {
               //decide if we are a unit or an old CX
               if (result.rows[i].bluid > 0) {
                   isBluid = true;
               } else {
                   isBluid = false;
               }
         
               sTmp += "<li data-id='" + result.rows[i].id + "' data-bluid='" + result.rows[i].bluid + "' data-blid='" + result.rows[i].blid + "' class='vc-list-item";
              
               if (result.rows[i].dsactive ===false) {
                   sTmp += " ignore";
               } else {


                   if (result.rows[i].active === false) {
                       sTmp += " inactive";
                   }
                   if (result.rows[i].online === false) {
                       sTmp += " offline";
                       sumBroken += 1;
                   }
               }
               sTmp += "'>";
               sTmp += "<div class='vc-list-col'>";
               sTmp += "<div class='vc-list-col vc-list-col-half'>";
               sTmp += "<div class='vc-list-col-element col1'><input type='checkbox' data-id='" + result.rows[i].id + "' class='chb' /></div>"; //end col

               list = "";
               if (result.rows[i].projects !== null) {
                   list = result.rows[i].projects.replace("{", "").replace("}", "").replace(/\"/g, "").replace(/,/g, ", ");
               }
               sTmp += "<div class='vc-list-col-element col2 ";
               if (list.length > 300) { sTmp += " smaller"; }
               sTmp += "'>";
               sTmp += "<div class='pic'>";
               if (isBluid) {
                   sTmp += "<img src='" + result.rows[i].pic + "' title='" + result.rows[i].unit + " (ID" + result.rows[i].bluid + ")' /><span style=' display: none;'>" + result.rows[i].unit + "</span>";
               } else {
                   sTmp += "PLC1.0";
               }
               sTmp += "</div>";
               sTmp += "<b>" + result.rows[i].host + "</b> ";
               if (list.length > 0) {
                   sTmp += " (" + list + ")";
               } else {
                   sTmp += "<br/>";
               }
               sTmp += "";
             

               //if (result.rows[i].online === false) {
                   sTmp += "<br/>" + result.rows[i].onlineTimestamp + " h";
               
              //if (result.rows[i].duplicate_serials) {
              //    sTmp += "<span title='" + me.resources.lblMacAddressDuplicate + ": " +result.rows[i].duplicate_serials +"'> <i class='fas fa-network-wired icon-color-error'></i><i class='fa fa-exclamation icon-color-error'></i><span style=' display: none;'>"+me.resources.lblMacAddressDuplicate +"</span></span>";
              //}
           
               sTmp += "</div>"; //end col2
               sTmp += "<div class='vc-list-col-element col3";

               sError = "";
               if (result.rows[i].errorConfig !== null) {
                   if (result.rows[i].errorConfig.length > 0) {
                       sError = result.rows[i].errorConfig;
                       sTmp += " error";
                   }
               }
               sTmp += "'>";
               sTmp += result.rows[i].task;
               if (result.rows[i].committedConfig === false) {
                   sTmp += " | <span><i class='fa fa-exclamation-triangle icon-color-error' title='Config dirty!'></i></span><span style=' display: none;'>config dirty</span>";
               }
               if (sError.length > 0) { sTmp += "<div class='smaller'>" + sError + "</div>"}
               sTmp += "</div>"; //end col3

              
               sTmp += "</div>"; //end col half
               sTmp += "<div class='vc-list-col vc-list-col-half'>";

               sTmp += "<div class='vc-list-col-element col6'>-</div>"; //end col4

               sTmp += "<div class='vc-list-col-element col4'>";
               list = result.rows[i].dstype.replace("{", "").replace("}", "").replace(/\"/g, "").replace(/,/g, ", ");
               if (list.length > 0) {
                   sTmp += list;
               } else {
                   sTmp += "<br/>";
               }
               sTmp += "</div>"; //end col4
               sTmp += "<div class='vc-list-col-element col5'>";
               list = result.rows[i].alarms.replace("{", "").replace("}", "").replace(/\"/g, "").replace(/,/g, ", ");
               if (list.length > 0) {
                   sumAlarms += 1;
                   sTmp += list + "<span style='display:none'>alarm</span>";
               } else {
                   sTmp += "<i class='fa fa-check icon-color-ok'></i>";
               }
              
               sTmp += "</div>"; //end col5
             
               sTmp += "<div class='vc-list-col-element col7'>";
               if (result.rows[i].tasks > 0) {
                   sumTasks += result.rows[i].tasks;
                   sTmp += result.rows[i].tasks + "<span style='display:none'>tasks</span>";
               } else {
                   sTmp += "<br/>";
               }
               sTmp += "</div>"; //end col7
               sTmp += "<div class='vc-list-col-element col8'>";
               if (result.rows[i].logs > 0) {
                   sTmp += result.rows[i].logs + "<span style='display:none'>logs</span>";
               } else {
                   sTmp += "<br/>";
               }
               sTmp += "</div>"; //end col8

               sTmp += "<div class='vc-list-col-element col9'><i class='icon-del fa fa-times icon-color-error vc-list-icon'></i></div>"; //end col9
               sTmp += "</div>"; //end col half
               sTmp += "</div>"; //end col
               sTmp += "</li>"; //end item
           }
           me.visual.find(".device-list .vc-list-selection").html(sTmp);

           me.filter();
           me.hideDetails();
           me.loadTickets();
           _VCMQ.produce(me.visual, me.vcgid, 'UNITSTATUS', { 'broken': sumBroken, "tasks": sumTasks, "alarms": sumAlarms });
           return true;
       });

        return true;
    } catch (ex) { me.writeError('fetchEntries', ex); return false }

}

UnitStatus.prototype.fetchOpenTickets = function () {
    /// <summary>
    ///  This function generates a vc-list with all given entries. 
    /// </summary>
    var me = this;
    var sTmp = "";
    var isBluid;
    var list;
    var sError;
    var sumTasks = 0;
    var sumAlarms = 0;
    var sumBroken = 0;

    try {
        if (me.error) {
            return false;
        }
       

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ "type": 2 }),
            function (result) {

                if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }
                me.openTickets = result;

                me.loadTickets();




                return true;
            });

        return true;
    } catch (ex) { me.writeError('fetchTickets', ex); return false }

}

UnitStatus.prototype.loadTickets = function () {
    /// <summary>
    ///  This function generates a vc-list with all given entries. 
    /// </summary>
    var me = this;
   

    try {
        if (me.error) {
            return false;
        }
        if (me.openTickets === null) { return true; }
        me.visual.find(".device-list .vc-list-selection .col6").html("<br/>");
      
        for (var i = 0; i < me.openTickets.length; i++) {
            me.visual.find(".device-list li[data-bluid='" + me.openTickets[i] + "'] .col6").html("<i data-bluid='" + me.openTickets[i] + "' class='vc-list-icon ticket fa-regular fa-ticket'></i>");
        }

        return true;
    } catch (ex) { me.writeError('loadTickets', ex); return false }

}



UnitStatus.prototype.delete = function (obj) {
    /// <summary>
    ///  This function sends the id for the entry we want to delete to the server. 
    /// </summary>
    var me = this;
    var param;
    var id;
    var bluid;
    try {
        if (me.error) {
            return false;
        }

        id = parseInt(obj.parents("li.vc-list-item").data("id"),10);
        bluid = parseInt(obj.parents("li.vc-list-item").data("bluid"),10);
        param = { "type": 2, "EntryList": [{"id": id, "bluid": bluid }]}
      

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
       function (result) {
          
           if (result === false) {
               me.showMessage(me.resources.err_saveData, true);
               return false;
           }
           me.fetchEntries();
           return true;
       });

        return true;
    } catch (ex) { me.writeError('delete', ex); return false }

}

UnitStatus.prototype.filter = function () {
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        //hide all
        me.visual.find(".device-list .vc-list-selection .vc-list-item").removeClass("found").data("counter", 0).hide();

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", ".device-list .vc-list-selection .vc-list-item", "found");

        me.visual.find(".device-list .vc-list-selection .vc-list-item.found").show();
        me.visual.find(".device-list .vc-list-selection .vc-list-item").removeClass("alt");
        me.visual.find(".device-list .vc-list-selection .vc-list-item.found:even").addClass("alt");
	    me.selectAllAlarms(me.visual.find("#chb-alarm-selection"));
     
        return true;
    } catch (ex) {
        me.writeError('filter', ex);
        return false;
    }

};


UnitStatus.prototype.selectAll = function (obj) {
    /// <summary>
    /// This function handles the select/unselect functionality <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        if (obj.is(":checked")) {
            me.visual.find(".vc-list-item.found input").prop("checked", true);
            me.activateBtnCmd(true);
        } else {
            me.visual.find(".vc-list-item input").prop("checked", false);
            me.activateBtnCmd(false);
        }

        return true;
    } catch (ex) { me.writeError('selectAll', ex); return false; }
};

  UnitStatus.prototype.selectAllAlarms = function (obj) {
    /// <summary>
    /// This function handles the select/unselect functionality of alarms<br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

	    if (obj.is(":checked")) {
		    me.visual.find(".vc-list-item.found:has(.col5 .icon-color-ok)").hide();
	    } else {
		    me.visual.find(".vc-list-item.found:has(.col5 .icon-color-ok)").show();
	    }
	    me.visual.find(".device-list .vc-list-selection .vc-list-item").removeClass("alt");
        me.visual.find(".device-list .vc-list-selection .vc-list-item.found:even").addClass("alt");

        return true;
    } catch (ex) { me.writeError('selectAll', ex); return false; }
};


UnitStatus.prototype.setCmd = function (obj) {
    /// <summary>
    ///  This function takes a cmd from the tasks dropdown, replaces the dates and copies it to the input field.
    /// </summary>
    var me = this;
    var cmd;
 
    try {
        if (me.error) { return false;}

        cmd = obj.val();

        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0
        var yyyy = today.getFullYear();
        today = dd + '.' + mm + '.' + yyyy;

        cmd = cmd.replace(/\[DAY]/g, today);
        me.visual.find("#txt-cmd").val(cmd);

        me.activateBtnCmd(true);
        return true;
    } catch (ex) { me.writeError('setCmd', ex); return false }

}



UnitStatus.prototype.sendCmd = function () {
    /// <summary>
    ///  This function generates a list of selected entry ids and sends the list incl. the task (cmd) to the server.
    /// </summary>
    var me = this;
    var param;
    var id;
    var bluid;
    var list = [];
    var cmd;
    try {
        if (me.error) {
            return false;
        }


        if (me.visual.find("#div-btn-send").hasClass("active") === false) {return true}

        cmd = trimAll(me.visual.find("#txt-cmd").val());
        if (cmd.length ===0) {return true}
      
        me.visual.find(".vc-list-item .col1 .chb:checked").each(function() {
            if ($(this).parents("li.vc-list-item").hasClass("found") && $(this).parents("li.vc-list-item").is(":visible")) {
                id = parseInt($(this).parents("li.vc-list-item").data("id"), 10);
                bluid = parseInt($(this).parents("li.vc-list-item").data("bluid"), 10);
                list.push({ "id": id, "bluid": bluid });
            }

        });
        param = { "type": 1, "EntryList": list, "Cmd": cmd }

        if (list.length === 0) {return true}
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
       function (result) {

           if (result === false) {
               me.showMessage(me.resources.err_saveData, true);
               return false;
           }
           me.fetchEntries();
           me.visual.find("#chb-selection").prop("checked", false);
           me.activateBtnCmd(false);
           return true;
       });

        return true;
    } catch (ex) { me.writeError('sendCmd', ex); return false }

}


UnitStatus.prototype.activateBtnCmd = function (bActivate) {
    /// <summary>
    ///  This function activates/deactivates the send-button
    /// </summary>
    var me = this;
    var cmd;
    var list;
    try {
       
        cmd = trimAll(me.visual.find("#txt-cmd").val());
        list = me.visual.find(".vc-list-item .col1 .chb:checked");
        if (bActivate) {
            if ((cmd.length > 0) && (list.length > 0)) {
                me.visual.find("#div-btn-send").addClass("active");
            } else {
                me.visual.find("#div-btn-send").removeClass("active");
            }
        } else {
            me.visual.find("#div-btn-send").removeClass("active");
        }

    } catch (ex) { me.writeError('activateCmdBtn', ex); }

}



UnitStatus.prototype.showDetails = function (obj) {
    /// <summary>
    ///  This function opens/hides the detail view. When it opens the details it makes the vc-list smaller and shows the currently selected entry only.
    /// </summary>
    var me = this;
    var h;
    try {
        if (me.error) { return false; }
       
        if (me.visual.find(".div-details").is(":visible")) {
           return me.hideDetails();
        } else {
            me.visual.find(".div-details-menu .button-toggle").removeClass("button-toggle-active");
            me.visual.find(".div-details-menu #btn-detail-ticket").addClass("button-toggle-active");
            me.visual.find(".device-list .vc-list-selection .vc-list-item").hide();
            //show the currently selected entry
            obj.show();
            
            h = parseInt(me.visual.find(".device-list .vc-list-header").height() + obj.height() + 20, 10);
            me.visual.find(".vc-list.device-list ").height(h);

            me.visual.find(".div-details-content").height(parseInt(me.listHeight - h - 50, 10));
            me.visual.find(".div-details").height(parseInt(me.listHeight - h, 10)).show();

            //save the current object for the detail menu
            me.currentDetailObj = obj;

            me.showDetailContent();

            return true;
        }

    } catch (ex) { me.writeError('showDetails', ex); return false }

}



UnitStatus.prototype.showDetailContent = function () {
    /// <summary>
    ///  This function opens a visual based on the selected menu point in the details. 
    /// </summary>
    var me = this;
    var type;
    var visual;
    var h;
    var w;
    var param;
    var signalParam;
    var bluid;
    var blid;
    var showVisual = false;
    try {
        if (me.error) { return false; }
        //get the type of the currently active button
        type = me.visual.find(".div-details-menu .button-toggle-active").data("type");
        param = "";
        signalParam = "";
        visual = "";
        h = parseInt($(".div-details-content").height(), 10);
        w = parseInt($(".div-details-content").width()-20, 10);

        bluid = parseInt(me.currentDetailObj.data("bluid"), 10);
        blid = parseInt(me.currentDetailObj.data("blid"), 10);

        //we generate a random sub container every time 
        var container = me.getRandomIDContainerObj("div-details-content-", true);
        me.visual.find(".div-details-content").html(container.obj);

        switch (type) {
            case "alarm":
                visual = "VISUAL_ALARMHISTORY";
               
                if (bluid > 0) {
                    param = JSON.stringify({"UnitID": bluid,"ShowUnitOnly": true,"AllProjects": false, "FixedContentHeight":true});
                } else {
                    param = JSON.stringify({ "LoggerID": blid, "AllProjects": false, "FixedContentHeight": true });
                }
                break;
            case "ticket":
                me.visual.find(".div-details-content").TicketList({ invokeType: "addVisualBase", parameter: { ReadOnlyMode:true, 'BLUID': bluid } });
                break;
            case "digital":
                visual = 'VISUAL_DIGITALTREND';
                showVisual = true;
                if (bluid > 0) {
                    param = bluid;
                    signalParam = JSON.stringify({ 'DigitalTrendType': 3 });
                } else {
                    param = blid;
                    signalParam = JSON.stringify({ 'DigitalTrendType': 1 });
                }

                break;
            case "tasks":
                h -= 40;
                visual = 'VISUAL_UNITSTATUS_TASKS';
                param = JSON.stringify({ 'UnitID': bluid, 'LoggerID': blid });
                signalParam = "";
                break;
            case "logs":
                h -= 40;
                visual = 'VISUAL_UNITSTATUS_LOGS';
                param = JSON.stringify({ 'UnitID': bluid, 'LoggerID': blid });
                signalParam = "";
                break;
        default:
        }
        if (visual.length === 0) { return false }
        if (showVisual) {
            me.vcVisual.addVisualByName("div-details-content-",visual,container.random,getCurrentTimestamp(),h,w,param,signalParam,1);
        } else {
            me.vcVisual.addVisualBaseByName("div-details-content-",visual,container.random,getCurrentTimestamp(),h, w,param,signalParam,1);
        }

        return true;

    } catch (ex) { me.writeError('showDetailContent', ex); return false }

}



UnitStatus.prototype.hideDetails = function () {
    /// <summary>
    ///  This function hides the details and resets the height of the vc-list
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        me.visual.find(".div-details").hide();
        me.visual.find(".vc-list.device-list ").height(me.listHeight);
        me.filter();
        return true;
      
    } catch (ex) { me.writeError('hideDetails', ex); return false }

}

UnitStatus.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
           me.visual.find(" #div-menu,.vc-list-header, .vc-list-selection").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};



function UnitStatusLists() {
    /// <summary>
    /// This object provides js functions for the Widget.Status.Tasks and Widget.Status.Logs <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 18.7.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 17.7.2019                                               *<br />
    /// **********************************************************************<br />
    /// * - added optional time filter for log entries                       *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 18.7.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.listHeight = 0;
    this.initCal = false;
}

UnitStatusLists.prototype = new vcTemplate();

UnitStatusLists.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);

        me.listHeight = parseInt(me.height - me.visual.find("#div-menu-left").height() - 30, 10);
        me.visual.find(".vc-list").height(me.listHeight);

        me.visual.find("#chb-tasks-selection").off("click").on("click", function () { me.selectAll($(this)); });
        me.visual.find("#div-btn-del").off("click").on("click", function () { me.delete() }).button();
        me.initSpecific();


        return true;
    } catch (ex) { me.writeError('init', ex); return false }

}



UnitStatusLists.prototype.fetchEntries = function () {
    /// <summary>
    ///  This function generates a vc-list based on the given entries. 
    /// </summary>
    var me = this;
    var sTmp = "";
    var dates;
    try {
        if (me.error) {
            return false;
        }
     
        if (me.initCal ===false) { return false;
        }
        me.visual.find(".vc-list-selection").html(me.vcC.getLoadingIcon());

 
        dates = me.visual.find("#div-calender-lists").vcDate("getDateRange");



        window.VisualCoreService.getData(me.vcvid,
            me.vcgid,
            getCurrentTimestamp(),
            0,
            0,
            '',
            '',
            1,
            2,
            JSON.stringify({
                "type": 1,
                "LoggerID": me.LoggerID,
                "UnitID": me.UnitID,
                "StartDate": dates.from,
                "EndDate": dates.to
            }),
            function(result) {

                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                if (result.rows === null) {
                    me.visual.find(".vc-list-selection")
                        .html("<div class='note'>" + me.resources.noEntriesExist + "</div>");
                    return false;
                }

                for (var i = 0; i < result.rows.length; i++) {
                    sTmp += me.generateSingleEntry(result.rows[i]);
                }

                me.visual.find(".vc-list-selection").html(sTmp);
                me.visual.find(".vc-list-selection .vc-list-item:even").addClass("alt");

                return true;
            });

        return true;
    } catch (ex) {
     
        me.writeError('fetchEntries', ex); return false
    }

}

UnitStatusLists.prototype.generateSingleEntry = function () {
    return "";
}

UnitStatusLists.prototype.initSpecific = function () {
    return "";
}

UnitStatusLists.prototype.selectAll = function (obj) {
    /// <summary>
    /// This function handles the select/unselect functionality <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        if (obj.is(":checked")) {
            me.visual.find(".vc-list-item input").prop("checked", true);
          
        } else {
            me.visual.find(".vc-list-item input").prop("checked", false);
          
        }

        return true;
    } catch (ex) { me.writeError('selectAll', ex); return false; }
};



UnitStatusLists.prototype.delete = function () {
    /// <summary>
    ///  This function generates an id-list with all selected items and sends them to the server for deleting.
    /// </summary>
    var me = this;
    var param;
    var id;
    var list = [];
    try {
        if (me.error) {
            return false;
        }


        me.visual.find(".vc-list-item  .chb:checked").each(function () {      
            id = parseInt($(this).parents("li.vc-list-item").data("id"), 10);
            list.push({ "id": id });
        });
        param = { "type": 2, "EntryList": list, "UnitID": me.UnitID,  "LoggerID": me.LoggerID}


        if (list.length === 0) { return true }

        me.visual.find("#div-btn-del").button("option", "disabled", true);

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
       function (result) {

           if (result === false) {
               me.showMessage(me.resources.err_saveData, true);
               return false;
           }
           me.fetchEntries();
           me.visual.find("#chb-selection").prop("checked", false);
           me.visual.find("#div-btn-del").button("option", "disabled", false);

           return true;
       });

        return true;
    } catch (ex) { me.writeError('sendCmd', ex); return false }

}


UnitStatusLists.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("#div-menu-left,#div-btn-del,.vc-list ").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};





function UnitStatusTasks() {
    /// <summary>
    /// This object provides js functions for the Widget.Status.Tasks <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 18.7.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 18.7.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}

UnitStatusTasks.prototype = new UnitStatusLists();


UnitStatusTasks.prototype.generateSingleEntry = function (row) {
    /// <summary>
    ///  This function generates one sinlge ros for the vc-list based on the given entries.  
    /// </summary>
    var me = this;
    var sTmp;
    try {
        if (me.error) {
            return false;
        }

        sTmp = "<li data-id='" + row.id + "' class='vc-list-item'>";
        sTmp += "<div class='vc-list-col'><div class='vc-list-col-element'>";
        if (row.status === 1) {
            sTmp += "<b>";
        };
        sTmp += "<input type='checkbox' data-id='" + row.id + "' class='chb' /> " + $("<div/>").html(row.task).text();
        if (row.status === 1) {
            if (row.parameter !== null) {
                sTmp += " (" + row.parameter + ")";
            } else {
                sTmp += " (sent)";
            }
            sTmp += "</b>";        }
        
        sTmp += "</div></div>"; //end col
   
        return sTmp;
    } catch (ex) { me.writeError('generateSingleEntry', ex); return "" }
}

UnitStatusTasks.prototype.initSpecific = function () {
    /// <summary>
    ///  This function optionally inits the calender 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.initCal = true;
        me.fetchEntries();
        return true;
    } catch (ex) { me.writeError('initSpecific', ex); return false}
}



function UnitStatusLogs() {
    /// <summary>
    /// This object provides js functions for the Widget.Status.Logs <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 18.7.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 18.7.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}

UnitStatusLogs.prototype = new UnitStatusLists();

UnitStatusLogs.prototype.initSpecific = function () {
    /// <summary>
    ///  This function optionally inits the calender 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find("#div-calender-lists")
            .vcDate({
                mode: 'Range', align: 'middle', interval: 1, langID: me.userLangidForCulture, callback: function () {
                    me.fetchEntries();
                    me.initCal = true;
                }
            });
        return true;
    } catch (ex) { me.writeError('initSpecific', ex); return false }
}

UnitStatusLogs.prototype.generateSingleEntry = function (row) {
    /// <summary>
    ///  This function generates one sinlge ros for the vc-list based on the given entries. 
    /// </summary>
    var me = this;
    var sTmp;
    try {
        if (me.error) {
            return false;
        }

        sTmp = "<li data-id='" + row.id + "' class='vc-list-item'>";
        sTmp += "<div class='vc-list-col'><div class='vc-list-col-element'>";
        sTmp += "<input type='checkbox' data-id='" + row.id + "' class='chb' /> ";
        if (row.log_type === 1) {
            sTmp += "<i class='fa-regular fa-times-circle icon-color-error vc-list-icon' />";
        } else {
            sTmp += "<i class='fa fa-check icon-color-ok vc-list-icon' />";
        }
        sTmp += " " + row.time + " - " + row.text;
        sTmp += "</div></div>"; //end col
        sTmp += "</li>"; //end item

        return sTmp;
    } catch (ex) { me.writeError('generateSingleEntry', ex); return "" }

}